interface PasswordConfig {
  specialChars: string;
  minLength: number;
}

type Policies = Record<string, (password: string) => boolean>;

export default function usePasswordPolicy(passwordConfig: PasswordConfig) {
  const policies: Policies = {
    passwordLength: (password: string) =>
      password.length >= passwordConfig.minLength,
    passwordUppercase: (password: string) => /[A-Z]/.test(password),
    passwordLowercase: (password: string) => /[a-z]/.test(password),
    passwordNumber: (password: string) => /\d/.test(password),
    passwordSpecial: (password: string) =>
      password
        .split("")
        .some((char) => passwordConfig.specialChars.includes(char)),
  };

  return {
    keys: Object.keys(policies),
    check: (key: string, password: string) => {
      if (!policies[key]) {
        throw new Error(`Invalid policy key: ${key}`);
      }
      return policies[key](password);
    },
  };
}
